module.exports = __webpack_public_path__ + "media/application/images/2018/icon-dont-buy-12d11d55f78cf97fd9ba66313b6f199e.svg";